<template>
  <basic
    v-if="modelName === 'Basic'"
    :name="formDatas.name"
    :description="formDatas.description"
    :personnal="formDatas.data.personnal"
    :formations="formDatas.data.formations"
    :pros="formDatas.data.pros"
    :competences="formDatas.data.competences"
    :langues="formDatas.data.langues"
    :hobbies="formDatas.data.hobbies"
    :color="modelColor"
  />

  <basic-2
    v-else-if="modelName === 'Basic2'"
    :name="formDatas.name"
    :description="formDatas.description"
    :personnal="formDatas.data.personnal"
    :formations="formDatas.data.formations"
    :pros="formDatas.data.pros"
    :competences="formDatas.data.competences"
    :langues="formDatas.data.langues"
    :hobbies="formDatas.data.hobbies"
    :color="modelColor"
  />

  <basic-3
    v-else-if="modelName === 'Basic3'"
    :name="formDatas.name"
    :description="formDatas.description"
    :personnal="formDatas.data.personnal"
    :formations="formDatas.data.formations"
    :pros="formDatas.data.pros"
    :competences="formDatas.data.competences"
    :langues="formDatas.data.langues"
    :hobbies="formDatas.data.hobbies"
    :color="modelColor"
  />

  <dashboard
    v-else-if="['Dashboard', 'Dashboard2'].includes(modelName)"
    :name="formDatas.name"
    :description="formDatas.description"
    :personnal="formDatas.data.personnal"
    :formations="formDatas.data.formations"
    :atouts="formDatas.data.atouts"
    :competences="formDatas.data.competences"
    :success="formDatas.data.success"
    :needs="formDatas.data.needs"
    :langues="formDatas.data.langues"
    :hobbies="formDatas.data.hobbies"
    :color="modelColor"
    :type-dashboard="modelName"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import Basic from './Basic.vue';
import Basic2 from './Basic2.vue';
import Basic3 from './Basic3.vue';
import Dashboard from './Dashboard.vue';

export default {
  components: {
    Basic,
    Basic2,
    Basic3,
    Dashboard,
  },

  props: {
    modelName: String,
    modelColor: String,
    form: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      backdoor: 'app/backdoor',
    }),

    formDatas() {
      if (this.form !== null && Object.keys(this.form).length > 0) {
        // For real time preview
        this.backdoor; //for reactivity
        return this.form;
      }

      // For model in shaping choice page
      return {
        description:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec rutrum congue leo eget malesuada. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi.',
        name: 'Vestibulum ac diam',
        data: {
          personnal: {
            prenom: { isDisplayed: true, value: 'Donec' },
            nom: { isDisplayed: true, value: 'Molestie' },
            date_naissance: { isDisplayed: true, value: new Date() },
            telephone: { isDisplayed: true, value: '0606060606' },
            email: { isDisplayed: true, value: 'donec.molestie@mail.com' },
            adresse: {
              isDisplayed: true,
              value: '1 Rue de la paix 75000 Paris',
            },
            travailleur_handicape: { isDisplayed: true, value: true },
            permis_conduire: { isDisplayed: true, value: ['B', 'A1'] },
            moyen_transport: {
              isDisplayed: true,
              value: ['Voiture', 'Bus', 'Train', 'Vélo'],
            },
            site_web: { isDisplayed: true, value: 'http://donecmolestie.cv' },
            linkedin: {
              isDisplayed: true,
              value: 'http://www.linkedin.fr/prenomnom',
            },
            profile_image: { isDisplayed: true, value: null },
          },
          formations: [
            {
              isDisplayed: true,
              value: {
                type: '',
                value: {
                  intitule_parcours: 'Intitulé de formation',
                  debut_parcours: new Date('01/01/2008'),
                  fin_parcours: new Date('01/01/2012'),
                  localisation_parcours: 'Ville',
                  niveau_cursus: '',
                  etablissement_cursus: '',
                },
              },
            },
            {
              isDisplayed: true,
              value: {
                type: '',
                value: {
                  intitule_parcours: 'Diplôme et titre',
                  debut_parcours: new Date('01/01/2005'),
                  fin_parcours: new Date('01/01/2006'),
                  localisation_parcours: 'Localisation',
                  niveau_cursus: '',
                  etablissement_cursus: '',
                },
              },
            },
            {
              isDisplayed: true,
              value: {
                type: '',
                value: {
                  intitule_parcours: 'Diplôme et titre',
                  debut_parcours: new Date('01/01/2003'),
                  localisation_parcours: 'Région',
                  niveau_cursus: '',
                  etablissement_cursus: '',
                },
              },
            },
          ],
          pros: [
            {
              isDisplayed: true,
              value: {
                type: '',
                value: {
                  intitule_parcours: 'Intitulé du poste',
                  debut_parcours: new Date('01/01/2018'),
                  fin_parcours: '',
                  localisation_parcours: '',
                  structure_accueil_parcours:
                                        'Nom de l’entreprise',
                  aborde_parcours:
                                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
                },
              },
            },
            {
              isDisplayed: true,
              value: {
                type: '',
                value: {
                  intitule_parcours: 'Intitulé du poste',
                  debut_parcours: new Date('01/01/2015'),
                  fin_parcours: new Date('01/01/2017'),
                  localisation_parcours: '',
                  structure_accueil_parcours:
                                        'Nom de l’entreprise',
                  aborde_parcours:
                                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
                },
              },
            },
            {
              isDisplayed: true,
              value: {
                type: '',
                value: {
                  intitule_parcours: 'Intitulé du poste',
                  debut_parcours: new Date('01/01/2011'),
                  fin_parcours: new Date('01/01/2013'),
                  localisation_parcours: '',
                  structure_accueil_parcours:
                                        'Nom de l’entreprise',
                  aborde_parcours:
                                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
                },
              },
            },
          ],
          competences: {
            'Métier 1': [
              { isDisplayed: true, value: 'Compétence 1' },
              { isDisplayed: true, value: 'Compétence 2' },
              { isDisplayed: true, value: 'Compétence 3' },
              { isDisplayed: true, value: 'Compétence 4' },
            ],
            'Métier 2': [{ isDisplayed: true, value: 'Compétence 32' }],
            'Formation 1': [
              { isDisplayed: true, value: 'Compétence 11' },
              { isDisplayed: true, value: 'Compétence 41' },
            ],
          },
          langues: [
            {
              isDisplayed: true,
              value: { name: 'Anglais', niveau: 2 },
            },
            {
              isDisplayed: true,
              value: { name: 'Espgnol', niveau: 3 },
            },
            {
              isDisplayed: true,
              value: { name: 'Allemand', niveau: 1 },
            },
          ],
          hobbies: [
            {
              isDisplayed: true,
              value: 'Football',
              image:
                'https:\/\/images.unsplash.com\/photo-1560272564-c83b66b1ad12?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjYyODh8MHwxfHNlYXJjaHwzfHxmb290YmFsbHxlbnwwfHx8fDE2NjM5NjczNDk&ixlib=rb-1.2.1&q=80&w=200',
              icon: 'medal',
            },
            {
              isDisplayed: true,
              value: 'Cinéma',
              image:
                'https:\/\/images.unsplash.com\/photo-1542204165-65bf26472b9b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjYyODh8MHwxfHNlYXJjaHw2fHxtb3ZpZXxlbnwwfHx8fDE2NjQxODU5Mjc&ixlib=rb-1.2.1&q=80&w=200',
              icon: 'film',
            },
            {
              isDisplayed: true,
              value: 'Musique',
              image:
                'https:\/\/images.unsplash.com\/photo-1507838153414-b4b713384a76?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjYyODh8MHwxfHNlYXJjaHwyfHxtdXNpY3xlbnwwfHx8fDE2NjQxODU4ODU&ixlib=rb-1.2.1&q=80&w=200',
              icon: 'headphones',
            },
          ],
          atouts: {
            value: {
              default: [
                'Adaptabilit\u00e9',
                'Altruisme',
                null,
                null,
                'Appartenance',
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                'Camaraderie',
                null,
                null,
                null,
                null,
              ],
              perso: [
                {
                  fromNeopass: false,
                  isDisplayed: true,
                  value: 'Atout Personnel',
                },
              ],
            },
          },
          success: {
            value: {
              workplace: ['dehors', 'flex office'],
              conditions: ['horaires variables', 'temps partiel'],
              teamwork: ['seul'],
              office: ['Poste am\u00e9nag\u00e9'],
            },
          },
          needs: {
            value: {
              default: [
                'De d\u00e9fi',
                null,
                null,
                null,
                'Des projets \u00e0 long terme',
                null,
                null,
                'D\'\u00eatre ind\u00e9pendant',
                null,
                'D\'esprit d\'\u00e9quipe',
                null,
                null,
                'De s\u00e9curit\u00e9',
              ],
              perso: [],
            },
          },
        },
      };
    },
  },
};
</script>
